export const toUpload = (file: string | null | undefined): string | null => {
  if (/^data:(.*?)base64,/.test(file!)) {
    return file!.split(',').pop() ?? null;
  }

  return null;
};
